const Check = () => {
  return (
    <svg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='m4 9.121 2.4 2.546L12 5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default Check;
